import { dayjs, VisualAlertDateTargetUnit, VisualAlertDateTargetMode } from '@keepeek/commons';
import { getFieldValue } from './getFieldValue.js';
import { isExpiredSince } from './isExpiredSince.js';
import { isExpiredSinceLessThan } from './isExpiredSinceLessThan.js';
import { isExpireWithin } from './isExpireWithin.js';

/**
 *
 *                                                                                      \
 * --------------------------------------------------------------------------------------\
 *     --- EXPIRED_SINCE_TARGETTED_DATE ---- today ---- EXPIRE_WITHIN_TARGETTED_DATE ---- >
 * --------------------------------------------------------------------------------------/
 *                                                                                      /
 *
 * @param element the media
 * @param fieldInternalName the internal name to get value from
 * @param dateTargetMode to check if a date is expired and since when, or if a date expire in the next [...]
 * @param dateTargetNumber number of days, months etc
 * @param dateTargetUnit date unit (days, month etc)
 * @returns whether or not a Tag has to be displayed according to the date parameters
 */
function isDateEligibleToDisplayVisualAlert(element, fieldInternalName, dateTargetMode, dateTargetNumber, dateTargetUnit) {
    if (!dateTargetMode || !dateTargetNumber || !dateTargetUnit || !fieldInternalName) {
        return false;
    }
    var fieldValue = getFieldValue(element, fieldInternalName);
    if (!fieldValue) {
        return false;
    }
    var fieldValueAsDate = new Date("".concat(fieldValue));
    var fieldValueAsDateJs = dayjs(fieldValueAsDate);
    var todayDate = new Date();
    var todayDateJs = dayjs(todayDate);
    // this is an enum from conf, no risks to have this not
    var dayJsUnitTechnicalKey = "d";
    if (dateTargetUnit === VisualAlertDateTargetUnit.Months) {
        dayJsUnitTechnicalKey = "M";
    }
    else if (dateTargetUnit === VisualAlertDateTargetUnit.Years) {
        dayJsUnitTechnicalKey = "y";
    }
    switch (dateTargetMode) {
        case VisualAlertDateTargetMode.ExpiredSince:
            return isExpiredSince(todayDateJs, dateTargetNumber, dayJsUnitTechnicalKey, fieldValueAsDateJs);
        case VisualAlertDateTargetMode.ExpiredSinceLessThan:
            return isExpiredSinceLessThan(todayDateJs, fieldValueAsDateJs, dayJsUnitTechnicalKey, dateTargetNumber);
        case VisualAlertDateTargetMode.ExpireWithin:
            return isExpireWithin(todayDateJs, dateTargetNumber, dayJsUnitTechnicalKey, fieldValueAsDateJs);
        default:
            return false;
    }
}

export { isDateEligibleToDisplayVisualAlert };
//# sourceMappingURL=isDateEligibleToDisplayVisualAlert.js.map
